var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass:
            "top-chat-ia-header d-flex align-center justify-space-between"
        },
        [
          _c("div", { staticClass: "d-flex align-center" }, [
            _c(
              "div",
              { staticClass: "top-chat-ia-header__avatar" },
              [
                _c("icon-svg", {
                  attrs: {
                    name: "ia-w-mark",
                    size: 20,
                    color: "var(--aawz-green-color)"
                  }
                })
              ],
              1
            ),
            _c("div", { staticClass: "top-chat-ia-header__text ml-2" }, [
              _c("div", { staticClass: "top-chat-ia-header__title" }, [
                _vm._v("AAWZ Intelligence")
              ]),
              _c("div", { staticClass: "top-chat-ia-header__subtitle" }, [
                _vm._v(" " + _vm._s(_vm.subtituloDoHeader) + " ")
              ])
            ])
          ]),
          _c(
            "div",
            { staticClass: "d-flex align-center top-chat-ia-header__actions" },
            [
              !_vm.showConversation
                ? _c(
                    "v-btn",
                    {
                      staticClass: "top-chat-ia-header__icon-btn",
                      attrs: {
                        icon: "",
                        small: "",
                        "aria-label": "Ver histórico",
                        title: "Ver histórico"
                      },
                      on: {
                        click: function($event) {
                          return _vm.$emit("setShowConversation")
                        }
                      }
                    },
                    [
                      _c("icon-svg", {
                        attrs: {
                          name: "clock-filled",
                          color: "var(--neutral-700)",
                          size: "18"
                        }
                      })
                    ],
                    1
                  )
                : _c(
                    "button",
                    {
                      staticClass:
                        "top-chat-ia-header__icon-btn top-chat-ia-header__back-btn",
                      attrs: { type: "button", "aria-label": "Voltar" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("setShowConversation")
                        }
                      }
                    },
                    [
                      _c("icon-svg", {
                        attrs: { name: "mdi-arrow-left", size: "14" }
                      }),
                      _vm._v(" Voltar ")
                    ],
                    1
                  ),
              _c(
                "v-btn",
                {
                  staticClass: "top-chat-ia-header__icon-btn",
                  attrs: {
                    icon: "",
                    small: "",
                    "aria-label": "Novo chat",
                    title: "Novo chat"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("setNewMessage")
                    }
                  }
                },
                [
                  _c("icon-svg", {
                    attrs: {
                      name: "add-circle",
                      color: "var(--neutral-700)",
                      size: "18"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  staticClass: "top-chat-ia-header__icon-btn",
                  attrs: {
                    icon: "",
                    small: "",
                    "aria-label": "Chat em tela cheia",
                    title: "Chat em tela cheia"
                  },
                  on: { click: _vm.openModalFull }
                },
                [
                  _c("icon-svg", {
                    attrs: {
                      name: "maximize",
                      color: "var(--neutral-700)",
                      size: "18"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  staticClass: "top-chat-ia-header__icon-btn",
                  attrs: {
                    icon: "",
                    small: "",
                    "aria-label": "Fechar",
                    title: "Fechar"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("setShowChat")
                    }
                  }
                },
                [
                  _c("icon-svg", {
                    attrs: {
                      name: "close-circle",
                      color: "var(--neutral-700)",
                      size: "18"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c("globalModalChatIa")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }